var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChartOutline = function SvgBarChartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3s3-1.35 3-3V3c0-1.65-1.35-3-3-3m1 21c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1zm8-15c-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3s3-1.35 3-3V9c0-1.65-1.35-3-3-3m1 15c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1zM3 12c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3s3-1.35 3-3v-6c0-1.65-1.35-3-3-3m1 9c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1z"
  })));
};
export default SvgBarChartOutline;